var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentTxt = function SvgAttachmentTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    fillRule: "evenodd",
    d: "M12 7.5A1.5 1.5 0 0 0 10.5 9v8.25h3V7.5H12Zm1.5 23.25h-3v9.75A1.5 1.5 0 0 0 12 42h24a1.5 1.5 0 0 0 1.5-1.5v-.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M13.5 30.75h.75v7.5c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h-.75V6.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V38.25a1.5 1.5 0 0 1-1.347 1.492L39 39.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    fillRule: "evenodd",
    d: "M31.88 29.625v-11.25c0-.621-.504-1.125-1.125-1.125H14.25V6.75A.75.75 0 0 1 15 6h17.658l.342.393v7.482h6.506l.244.28V38.25A.75.75 0 0 1 39 39H15a.75.75 0 0 1-.75-.75v-6h16.125a1.5 1.5 0 0 0 1.5-1.5v-1.023a1.11 1.11 0 0 0 .005-.102Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M28.255 30.75H14.25v1.5h16.125a1.5 1.5 0 0 0 1.5-1.5v-1.023a1.128 1.128 0 0 1-1.12 1.023h-2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8CDFC",
    fillRule: "evenodd",
    d: "M9.005 17.25h21.75c.621 0 1.125.504 1.125 1.125v11.25l-.005.102a1.128 1.128 0 0 1-1.12 1.023H9.005a1.125 1.125 0 0 1-1.125-1.125v-11.25c0-.621.504-1.125 1.125-1.125Zm2.895 3.262v.958h1.969v5.405h1.142V21.47h1.96v-.958h-5.07Zm8.323 2.338-1.397-2.338h-1.319l1.987 3.181-2.013 3.182H18.8l1.424-2.32h.053l1.424 2.32h1.327l-1.995-3.182 1.96-3.181h-1.3l-1.416 2.338h-.053Zm3.314-2.338v.958h1.969v5.405h1.142V21.47h1.96v-.958h-5.071Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.537 20.512v.958h1.969v5.405h1.142V21.47h1.96v-.958h-5.071ZM20.223 22.85l-1.397-2.338h-1.318l1.986 3.181-2.013 3.182H18.8l1.423-2.32h.053l1.424 2.32h1.327l-1.995-3.182 1.96-3.181h-1.3l-1.416 2.338h-.053ZM11.9 20.512v.958h1.969v5.405h1.143V21.47h1.96v-.958H11.9Z"
  })));
};
export default SvgAttachmentTxt;